module.exports = fox._r("fonts/simplifica.woff2", __webpack_public_path__ + "fonts/3YNRuwd.woff2");


//////////////////
// WEBPACK FOOTER
// ./fonts/simplifica.woff2
// module id = 940
// module chunks = 4